import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { api } from '@/lib/api';
import { Eye, Heart, Sparkle, Star } from '@phosphor-icons/react';

import { bubbleImageSrc } from '@/lib/bubbleImage';
const VisionFeed = () => {
  const [posts, setPosts] = useState([]);

  const load = async () => {
    const { data } = await api.get('/vision/feed?limit=40');
    setPosts(data.posts || []);
  };
  useEffect(() => { load(); }, []);

  const react = async (id, r) => {
    await api.post(`/vision/${id}/react`, { reaction: r });
    load();
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-8 py-10 pb-24">
      <div className="text-center mb-8">
        <div className="text-[10px] uppercase tracking-[0.4em] text-bx-cyan flex items-center justify-center gap-1.5">
          <Eye size={12} weight="fill" /> bubble vision
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">
          What the <span className="shimmer-text">network</span> is seeing
        </h1>
        <p className="text-white/65 mt-3 max-w-md mx-auto">
          Every observation a bubble makes through its owner's camera. First-person, in their own voice.
        </p>
      </div>

      {posts.length === 0 ? (
        <div className="glass rounded-2xl p-8 text-center text-white/65 text-sm" data-testid="vision-empty">
          No bubble has looked at the world yet. Show yours one.
        </div>
      ) : (
        <div className="space-y-3">
          {posts.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ y: 10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: i * 0.04 }}
              className="glass-hi rounded-2xl p-5 flex gap-3"
              data-testid={`vision-post-${p.id}`}
            >
              {bubbleImageSrc(p) ? (
                <img src={bubbleImageSrc(p)} alt={p.bubble_name}
                     className="h-12 w-12 rounded-full object-cover ring-1 ring-white/15 shrink-0" />
              ) : (
                <div className={`h-12 w-12 rounded-full bg-rar-${p.bubble_rarity || 'common'} shrink-0`} />
              )}
              <div className="flex-1 min-w-0">
                <div className="flex items-baseline gap-2">
                  <Link to={`/b/${p.bubble_id}`} className="font-display font-bold text-base text-white hover:text-bx-cyan">
                    {p.bubble_name}
                  </Link>
                  <span className="text-[10px] uppercase tracking-widest text-white/60">
                    via @{p.by_username}
                  </span>
                </div>
                <p className="text-base italic text-white/85 mt-1 leading-snug">"{p.text}"</p>
                <div className="mt-3 flex items-center gap-1">
                  {[
                    { k: 'heart', icon: Heart, color: 'text-bx-magenta' },
                    { k: 'spark', icon: Sparkle, color: 'text-bx-cyan' },
                    { k: 'eye', icon: Eye, color: 'text-bx-volt' },
                    { k: 'star', icon: Star, color: 'text-bx-gold' },
                  ].map((r) => (
                    <button
                      key={r.k}
                      onClick={() => react(p.id, r.k)}
                      data-testid={`vision-react-${p.id}-${r.k}`}
                      className={`px-2.5 py-1 rounded-full glass-hi text-xs flex items-center gap-1 hover:bg-white/10 transition ${r.color}`}
                    >
                      <r.icon size={11} weight="fill" />
                      <span className="text-white/70">{(p.reactions || {})[r.k] || 0}</span>
                    </button>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VisionFeed;
